import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import OurServices from '../components/OurServices';
import FeaturedListings from '../components/FeaturedListings';
import PartnersStrip from '../components/PartnersStrip';
import PropertyCard from '../components/PropertyCard';
import PropertyCardSkeleton from '../components/PropertyCardSkeleton';
import GrowthPitch from '../components/GrowthPitch';
import RecentlyViewedSimilar from '../components/RecentlyViewedSimilar';
import { supabase } from '../supabaseClient';
import { useLanguage } from '../context/LanguageContext';
import './HomePage.css';

function mapRow(row) {
  return {
    id:               row.id,
    title:            row.title,
    price:            row.price,
    priceType:        row.price_label,
    type:             row.type,
    bedrooms:         row.beds,
    bathrooms:        row.baths,
    size:             row.sqm,
    city:             row.city,
    region:           row.area,
    address:          row.address,
    description:      row.description,
    features:         row.features || [],
    is_boosted:       row.is_boosted || false,
    is_partner:       row.is_partner || false,
    status:           row.status || 'active',
    sold_at:          row.sold_at || null,
    image:            row.images?.[0] || null,
    images:           row.images || [],
    gradient:         '#F2F1ED',
    created_at:       row.created_at || null,
    agent:            { name: row.contact_name || 'CosmoEstates Agent', phone: row.contact_phone || '+357 25 000 000', agency: row.agency_name || 'CosmoEstates' },
  };
}

export default function HomePage() {
  const { t } = useLanguage();
  const [recentListings, setRecentListings] = useState([]);
  const [recentLoading, setRecentLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    supabase
      .from('listings')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(4)
      .then(({ data }) => {
        if (cancelled) return;
        setRecentListings((data || []).filter(r => r.status !== 'archived' && r.status !== 'deleted').map(mapRow));
        setRecentLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  return (
    <main>
      <Hero />
      <OurServices />
      <FeaturedListings />

      {/* Ad Banner */}
      <div className="hp-ad">
        <div style={{maxWidth:1400,margin:'0 auto'}}>
          <div className="hp-ad__eyebrow">{t('home.adSponsored')}</div>
          <div className="hp-ad-box">
            <div className="hp-ad__icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
            </div>
            <div className="hp-ad__copy">
              <div className="hp-ad__title">{t('home.adTitle')}</div>
              <div className="hp-ad__sub">{t('home.adSub')}</div>
            </div>
            <a href="mailto:cosmoestatescyprus@gmail.com" className="hp-ad__cta">{t('home.adCta')}</a>
          </div>
        </div>
      </div>

      <PartnersStrip />

      <RecentlyViewedSimilar />

      {/* Recent Listings — render skeleton while loading so the section
          reserves space and there's no flash-of-empty or layout jump. */}
      {(recentLoading || recentListings.length > 0) && (
        <section className="homepage__recentListings">
          <div className="homepage__recentInner">
            <div className="homepage__recentHeader">
              <div className="homepage__recentEyebrow">
                <span className="homepage__recentEyebrowLine" />
                <span className="homepage__recentEyebrowText">{t('home.recent.eyebrow')}</span>
                <span className="homepage__recentEyebrowLine" />
              </div>
              <p className="homepage__recentSubtitle">{t('home.recent.subtitle')}</p>
              <Link to="/listings" className="homepage__recentViewAll">
                {t('home.boostedListings.viewAll')}
                <span className="homepage__recentViewAll__arrow">→</span>
              </Link>
            </div>
            <div className="homepage__recentGrid">
              {recentLoading
                ? [0, 1, 2, 3].map(i => <PropertyCardSkeleton key={`skel-${i}`} />)
                : recentListings.map((listing, i) => (
                    <PropertyCard key={listing.id} listing={listing} index={i} />
                  ))}
            </div>
          </div>
        </section>
      )}

      <GrowthPitch />
    </main>
  );
}
